<template>
  <div class="lottery-reward-image-comp" :style="rootStyle">
    <img class="image" :src="image" :alt="alt" />
    <img class="icon" :src="icon" alt="" v-if="icon" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { buildLotteryRewardTagSize } from '../service/lotteryService'

const props = withDefaults(
  defineProps<{
    image: string
    icon?: string
    alt?: string
    size?: number
  }>(),
  {
    alt: '',
    size: 66,
  }
)

const tagSize = computed(() => buildLotteryRewardTagSize(props.size))

const rootStyle = computed(() => ({
  width: `${props.size / 12}rem`,
  height: `${props.size / 12}rem`,
  '--tag-width': `${tagSize.value.width / 12}rem`,
  '--tag-height': `${tagSize.value.height / 12}rem`,
}))
</script>

<style lang="less">
.lottery-reward-image-comp {
  position: relative;

  > .image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  > .icon {
    position: absolute;
    top: 0;
    left: 0;
    width: var(--tag-width);
    height: var(--tag-height);
    object-fit: contain;
  }
}
</style>
